import { render, staticRenderFns } from "./inquiry_no_pass.vue?vue&type=template&id=6c80d054&scoped=true"
import script from "./inquiry_no_pass.vue?vue&type=script&lang=js"
export * from "./inquiry_no_pass.vue?vue&type=script&lang=js"
import style0 from "./inquiry_no_pass.vue?vue&type=style&index=0&id=6c80d054&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80d054",
  null
  
)

export default component.exports